import React, { Component } from "react";
import {
  MDBContainer, MDBNavbar,  MDBNavbarNav, MDBNavItem, MDBNavLink, MDBNavbarToggler, MDBCollapse, MDBFormInline,
  MDBDropdown, MDBDropdownToggle, MDBDropdownMenu, MDBDropdownItem, MDBIcon
} from "mdbreact";
import { Link } from 'gatsby';
import CustomNavLink from './customLink';
import { ReactComponent as Logo } from "../images/light-bulb.svg";

class NavbarPage extends Component {
  state = {
    isOpen: false
  };

  toggleCollapse = () => {
    this.setState({ isOpen: !this.state.isOpen });
  }

  render() {
    return (
      <MDBNavbar color="bg-primary" dark expand="md">
        <MDBContainer>
          
          <Link to="/" className="navbar-brand">
            <img src="https://smorasstats.com/v4/wp-content/uploads/2020/01/smil_logo.png" class="rounded-circle site-logo" />
            <strong className="ml-3 white-text">Smørås IL</strong>
          </Link>
          <MDBNavbarToggler name="navbar-toggler" onClick={this.toggleCollapse} />
          <MDBCollapse id="navbarCollapse3" isOpen={this.state.isOpen} navbar>
            <MDBNavbarNav left>
                <CustomNavLink to="/">Home</CustomNavLink>
                <CustomNavLink to="/innlegg">Innlegg</CustomNavLink>
                <CustomNavLink to="/lag">Lag</CustomNavLink>
                <MDBNavItem>
                <MDBDropdown>
                  <MDBDropdownToggle nav caret>
                    <div className="d-none d-md-inline">Om klubben</div>
                  </MDBDropdownToggle>
                  <MDBDropdownMenu right>
                    <Link className="dropdown-item" to="/historikk">Historikk</Link>
                    <Link className="dropdown-item" to="/sponsor">Sponsor</Link>
                    <Link className="dropdown-item" to="/om-klubben">Om klubben</Link>
                    <Link className="dropdown-item" to="/hostcup/hostcup-2019">Høstcup</Link>
                    <Link className="dropdown-item" to="/galleri">Galleri</Link>
                  </MDBDropdownMenu>
                </MDBDropdown>
                
               

              </MDBNavItem>
            </MDBNavbarNav>
            <MDBNavbarNav right>
              <div className="d-flex align-items-center">
                <a class="text-white mx-1" href="https://www.facebook.com/SmorasIl/">
                  <MDBIcon fab icon="facebook" className="ml-1" />
                </a>
                <a class="text-white mx-1" href="https://twitter.com/smorasil">
                  <MDBIcon fab icon="twitter" className="ml-1" />
                </a>
                <a class="text-white mx-1" href="https://www.instagram.com/smorasil/">
                  <MDBIcon fab icon="instagram" className="ml-1" />
                </a>
              </div>
            </MDBNavbarNav>
          </MDBCollapse>
        </MDBContainer>
      </MDBNavbar>
    );
  }
}

export default NavbarPage;
